module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "terminal"
    },
    on: {
      "click": _vm.focusCommandInput
    }
  }, [_c('input', {
    ref: "command",
    attrs: {
      "id": "command",
      "type": "text",
      "autofocus": "",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "spellcheck": "false"
    },
    domProps: {
      "value": _vm.command
    },
    on: {
      "input": _vm.updateCommandLine,
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.executeCommand($event)
      }, function($event) {
        if (!('button' in $event) && $event.keyCode !== 38) { return null; }
        return _vm.upArrow($event)
      }, function($event) {
        if (!('button' in $event) && $event.keyCode !== 40) { return null; }
        return _vm.downArrow($event)
      }, function($event) {
        if (!('button' in $event) && $event.keyCode !== 37) { return null; }
        return _vm.cancelEvent($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        return _vm.cancelEvent($event)
      }]
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_vm._l((_vm.commands), function(command) {
    return _c('command', {
      key: command.$index,
      attrs: {
        "value": command
      }
    })
  }), _vm._v(" "), (_vm.showCommandLine) ? _c('command-input', [_vm._v(_vm._s(_vm.command))]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d75bebb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Terminal.vue
// module id = 276
// module chunks = 1